import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';
import { useUI } from '../../context/UIContext';
import { useAuth } from '../../context/AuthContext';
import { IconClose, IconChevronRight, IconChevronLeft, IconUser, IconHeart } from '../common/Icons';
import { NavAnchor } from './Header';

// Slide-in drawer identical in behaviour to the reference: level-1 list, sub levels slide in from the right with a Back button.
export default function MobileMenu() {
  const { settings } = useSettings();
  const { menuOpen, setMenuOpen } = useUI();
  const { user, logout } = useAuth();
  const [active, setActive] = useState(null);
  const menu = settings.header?.menu || [];
  const close = () => {
    setMenuOpen(false);
    setTimeout(() => setActive(null), 300);
  };

  return (
    <div className={`sf-menu-wrapper sf-menu-wrapper-mobile fixed z-[80] inset-0 transition-colors duration-300 ${menuOpen ? 'is-open' : 'hidden'}`} onClick={close}>
      <div className={`sf-menu__content transition-transform duration-300 md:w-[450px] z-50 bg-white h-full overflow-hidden absolute inset-y-0 left-0 w-full ${menuOpen ? '' : '-translate-x-full'}`} onClick={(e) => e.stopPropagation()}>
        <button type="button" className="eg-drawer-close absolute top-3 right-3 p-2" onClick={close} aria-label="Close menu"><IconClose className="w-[20px] h-[20px]" /></button>
        <div className="flex flex-col h-full overflow-y-auto">
          <div className="sf-menu-content flex-grow flex flex-col justify-between transition-all">
            <ul className="w-full sf-menu-links pt-8">
              {menu.map((item, i) => {
                const has = item.children && item.children.length > 0;
                return (
                  <li key={item.id || i} className="list-none sf-link flex items-center relative">
                    {has ? (
                      <button type="button" className="w-full px-4 py-3 flex items-center justify-between relative text-left" onClick={() => setActive(i)}>
                        <span>{item.label}</span>
                        <span className="sf__toggle-submenu-mb flex items-center justify-center"><IconChevronRight className="w-[16px] h-[16px]" /></span>
                      </button>
                    ) : (
                      <NavAnchor to={item.url} className="w-full px-4 py-3 flex items-center justify-between relative" onClick={close}>
                        <span>{item.label}</span>
                      </NavAnchor>
                    )}
                  </li>
                );
              })}
            </ul>
            <div className="mt-6 mega-menu-customer border-t">
              <div className="p-4">
                <h2 className="font-medium text-xl mb-4">My Account</h2>
                {user ? (
                  <>
                    <Link to="/account" className="sf__btn sf__btn-primary mb-3 w-full block text-center" onClick={close}><IconUser className="inline w-4 h-4 mr-2" />{user.name || 'My account'}</Link>
                    <button type="button" className="sf__btn sf__btn-secondary w-full" onClick={() => { logout(); close(); }}>Log out</button>
                  </>
                ) : (
                  <Link to="/account" className="sf__btn sf__btn-primary mb-3 w-full block text-center" onClick={close}>Log in with WhatsApp</Link>
                )}
                <Link to="/wishlist" className="flex items-center mt-4" onClick={close}><IconHeart className="w-4 h-4 mr-2" /> Wishlist</Link>
              </div>
            </div>
          </div>
        </div>
        {/* Sub level panel */}
        {menu.map((item, i) => (
          <div key={`sub-${i}`} className={`sf-sub-links absolute inset-y-0 bg-white flex-col w-full transition-transform duration-300 ${active === i ? 'flex left-0' : 'hidden left-full'}`}>
            <div className="h-full overflow-y-scroll">
              <button type="button" className="back p-4 font-medium flex items-center" onClick={() => setActive(null)}>
                <IconChevronLeft className="w-[16px] h-[16px]" />
                <span className="ml-3">Back</span>
              </button>
              <ul className="pb-4">
                <li className="list-none"><NavAnchor to={item.url} className="block px-4 py-3 font-medium" onClick={close}>All {item.label}</NavAnchor></li>
                {(item.children || []).map((c, j) => (
                  <li key={j} className="list-none">
                    <NavAnchor to={c.url} className={`block px-4 py-3 ${c.children?.length ? 'pb-2 font-medium' : ''}`} onClick={close}>{c.label}</NavAnchor>
                    {c.children && c.children.length > 0 && (
                      <ul>
                        {c.children.map((l, k) => (
                          <li key={k}><NavAnchor to={l.url} className="block p-2 pl-8" onClick={close}>{l.label}</NavAnchor></li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
